export class ShowSectorByNameUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(NAME){
    const sector = await this.repository.getSectorFromNewsirByName(NAME)
    return sector
  }
}
